export default "__VITE_ASSET__b3d145d7__"